import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page27',
  templateUrl: './page27.component.html',
  styleUrls: ['./page27.component.css']
})
export class Page27Component implements OnInit {
  @Input() data: any;
  constructor() { }

  ngOnInit(): void {
  }

}
